import { makeStyles } from '@material-ui/styles';
import { getButtonSettings, getCMSSlot } from "tools/cmsBlockSettings";
import React from 'react';
import SimpleButton from './simple-button';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '0',
        '& .btn': {
            color: theme.palette.primary.background,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '12px 30px 12px 30px',
            fontSize: 16,
            background: theme.palette.primary.color,
            fontWeight: 400,
            borderRadius: '0px',
            letterSpacing: 0.5,
            textDecoration: 'none',
            pointerEvents: 'all',
            [theme.breakpoints.down('sm')]: {
                fontWeight: 400,
                letterSpacing: 0
            },
            '&.anni-dotd, .anni-dotd &': {
                backgroundClip: 'text',
				'-webkit-text-fill-color': 'transparent',
				'-webkit-background-clip': 'text',
				backgroundColor: '#B99354 !important',
				backgroundImage: 'linear-gradient(180deg, #FBD7A2, #B99354) !important',
				borderWidth: '1px !important',
                borderStyle: 'solid  !important',
                borderColor: '#B99354  !important',
				borderImageSlice: '1  !important',
				borderImageSource: 'linear-gradient(180deg, #FBD7A2, #B99354) !important',
            },
            '&.bf-dotd, .bf-dotd &': {
                backgroundClip: 'text',
                '-webkit-text-fill-color': 'transparent',
                '-webkit-background-clip': 'text',
                backgroundColor: '#fff !important',
                color: '#000 !important',
                backgroundImage: 'linear-gradient(180deg, #fff, #fff) !important',
                borderWidth: '1px !important',
                borderStyle: 'solid  !important',
                borderColor: '#fff  !important',
                borderImageSlice: '1  !important',
                borderImageSource: 'linear-gradient(180deg, #fff, #fff) !important',
            },
            '.gw-section &, .gw-section &:hover': {
                backgroundColor: '#ffffff !important',
                color: "#000 !important"
            },
            '.xmas &': {
                color: `${theme.palette.primary.background}`,
                //background: `${theme.palette.primary.main}`,
                border: '1px solid #fff',
                borderColor: '#fff',
            },
            '.&.bf-dotd': {
                color: `#000 !important`,
                background: `#fff !important`,
                border: '1px solid #fff !important',
                borderColor: '#fff',

                '-webkit-text-fill-color': '#fff',
            },
            '&.isBanner': {
                minWidth: '200px',
                '.xmas &': {
                    background: 'transparent',
                    color: '#fff',
                    border: '1px solid #fff',
                    '-webkit-text-fill-color': '#fff',
                },
                '.blackfriday &': {
                    background: '#fff !important',
                    color: '#222 !important',
                    border: '1px solid #fff !important',
                    '-webkit-text-fill-color': '#222',
                }
            },
        },
    },
}), { name: 'CmsButton' });

export default function CmsButton({ slots, block, slotName = 'button', isInBanner = false }) {
    const button = getCMSSlot(slotName, slots);
    const ButtonSettings = getButtonSettings(block, button.config);
    const classes = useStyles();

    if(button.config.title.value === '') {
        return '';
    }

    return (
        <div
            style={{
                ...ButtonSettings.styles.wrapper,
                marginBottom: !isInBanner ? '60px' : '0px'
            }}
            className={classes.wrapper}
        >
            <SimpleButton config={button.config} styles={ButtonSettings.styles.button}
                          buttonClass={[ButtonSettings.class, isInBanner ? 'isBanner' : ''].join(' ')}/>
        </div>
    );
}
